import { makeStyles, Divider,Typography,Button, 
    // createMuiTheme, 
    // ThemeProvider 
} from '@material-ui/core';
import { format} from 'date-fns';
import Cookies from 'js-cookie';
import React, { useEffect, useState , useRef} from 'react'
import { useSelector,useDispatch } from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import { getAllDataRiwayatPenjualan} from '../../../config/redux/action';
import { useReactToPrint } from 'react-to-print';

const PrintAllPenjualan = React.forwardRef ((props,ref) => {
    // const theme = createMuiTheme({
    //     typography:{
    //         fontFamily:[
    //             'Raleway',
    //         ]
    //     }
    // })
    const useStyle = makeStyles((theme)=>({
        root:{
            witdh:'100%',
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'center'
        },
        mainFaktur:{
            width:'21.59cm',
            marginTop:'30px'
        },
        content:{
            display:'flex',
            width:'98%',
            flexDirection:'column',
            alignItems:'center',
            borderBottom:'1px dotted black',
        },
        title:{
            textAlign:'center',
            paddingTop:'5px',
            paddingBottom:'5px',
            borderBottom:'1px dotted black',
        },
        tableBody:{
            height:'100%',
            textAlign:'center',
        },
        table:{
            marginTop:'3px',
            width:'100%',
        },
        tableContainer:{
            height:'100%',
            width:'100%',
            textAlign:'center',
        },
        tableHead:{
            borderTop:'1px dotted black',
            borderBottom:'1px dotted black'
        },
        mainWapper:{
            width:'98%',
            display:'flex',
            marginBottom:'0px',
            justifyContent:'space-between',
            marginTop:'5px',
        },
        subHeaderLeft:{
            width:'100%',
            display:'flex',
            justifyContent:'center'
        },
        subHeaderTlp:{
            width:'300px',
            display:'flex',
            paddingLeft:'20px'
        },
        subHeaderCenter:{
            width:'150px',
            display:'flex',
            flexDirection:'column',
            textAlign:'center',
        },
        subHeaderRight:{
            width:'250px',
            display:'flex',
            flexDirection:'column',
            alignItems:'flex-end',
            paddingRight:'20px'
        },
        subTitle:{
            width:'100%',
            display:'flex',
        },
        title1:{
            width:'90px'
        },
        title2:{
            width:'100px'
        },
        bottomTable:{
            borderBottom:'1px dotted black',
            paddingTop:'2px'
        },
        bottomPage:{
            display:'flex',
            flexDirection:'column',
            marginTop:'5px'
        },
        contentBottom:{
            width:'98%',
            display:'flex',
            flexDirection:"row",
            justifyContent:'flex-end',
            alignItems:'flex-end',
            borderBottom:'1px dotted black',
        },
        dottedBotton:{
            paddingRight:'10px',
            paddingLeft:'10px'
        },
        titleContentBottom:{
            textAlign:'right'
        },
        buttonLast:{
            display:'flex',
            flexDirection:'column',
            marginTop:'20px'
        },
    }));
    const {data} = useSelector(state => state.loginReducers);
    const {dataRiwayatPenjualan} = useSelector(state=>state.riwayatPenjualanReducers);
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const dispatch = useDispatch();
    const {tglawal,tglakhir}=useParams();
    const [totalOngkir,setTotalOngkir]=useState(0);
    const [totalDiskon,setTotalDiskon] = useState(0);
    const [totalPenjualan,setTotalPenjualan] = useState(0);
    useEffect(()=>{
    const data = {
        'tanggalAwal':tglawal,
        'tanggalAkhir':tglakhir
    }
    dispatch(getAllDataRiwayatPenjualan(data,token));
    if(dataRiwayatPenjualan.length>0){
        let totalPenjualan=dataRiwayatPenjualan.reduce((Penjualan,TotalP)=>{
            return Penjualan + TotalP.total
        },0)
        setTotalPenjualan(totalPenjualan);
        let totalOngkir=dataRiwayatPenjualan.reduce((Ongkir,TotalO)=>{
            return Ongkir + TotalO.ongkir
        },0)
        setTotalOngkir(totalOngkir);
        let totalDiskon=dataRiwayatPenjualan.reduce((Diskon,TotalD)=>{
            return Diskon + TotalD.diskon
        },0)
        setTotalDiskon(totalDiskon);
    }else{
        setTotalDiskon(0);
        setTotalOngkir(0);
        setTotalPenjualan(0);
    }
    },[dispatch,token,tglawal,tglakhir,totalPenjualan,totalDiskon,totalOngkir,dataRiwayatPenjualan])
    const classes = useStyle();
      const componentRef = useRef();
      const history = useHistory();
      const handlePrint = useReactToPrint({
        content:()=>componentRef.current,
      });
      const handleClickPrint = () =>{
          handlePrint();
          setTimeout(()=>{
            history.push('/historyPenjualan');
          },2000)
      }
      const listPenjualan = (
        <table aria-label="table barang" size="small" className={classes.tableContainer}>
            <thead>
                <tr>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>No Faktur</Typography></th>
                <th className={classes.tableHead} style={{width:'10%',textAlign:"center"}}><Typography variant='body2'>Pelanggan</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Tanggal</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Pembayaran</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Jatuh Tempo</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Diskon</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Ongkir</Typography></th>
                <th className={classes.tableHead} style={{width:'8%',textAlign:"center"}}><Typography variant='body2'>Total</Typography></th>
                </tr>
            </thead>
            <tbody>
            {dataRiwayatPenjualan.map((detailsToPrints=>(
                <tr className={classes.tableBody} key={detailsToPrints.idpenjualan}>
                    <td align="center"><Typography variant='caption'>{detailsToPrints.idpenjualan}</Typography></td>
                    <td align="center"><Typography variant='caption'>{detailsToPrints.pelanggan}</Typography></td>
                    <td align="center"><Typography variant='caption'>{format(new Date(detailsToPrints.tanggal),'dd/MM/yyyy')}</Typography></td>
                    <td align="center"><Typography variant='caption'>{detailsToPrints.pembayaran}</Typography></td>
                    <td align="center"><Typography variant='caption'>{format(new Date(detailsToPrints.jatuhtempo),'dd/MM/yyyy')}</Typography></td>
                    <td align="right"><Typography variant='caption'>{new Intl.NumberFormat().format(detailsToPrints.diskon)}</Typography></td>
                    <td align="right"><Typography variant='caption'>{new Intl.NumberFormat().format(detailsToPrints.ongkir)}</Typography></td>
                    <td align="right"><Typography variant='caption'>{new Intl.NumberFormat().format(detailsToPrints.total)}</Typography></td>
                </tr>
            )))}
            </tbody>
        </table>
      )
    return (
        <div className={classes.root}>
            <div className={classes.mainFaktur} ref={componentRef}>
                <Typography variant='h5' className={classes.subHeaderLeft}><b>Laporan Penjualan</b></Typography>
                <Typography variant='body1' className={classes.subHeaderLeft}><b>Periode {format(new Date(tglawal),'dd MMM yyyy')} s/d {format(new Date(tglakhir),'dd MMM yyyy')}</b></Typography>
                <Divider variant='middle'/>
                <div className={classes.content}>
                    <div className={classes.table}>
                     {listPenjualan}
                     </div>
                </div>
                    {/* <div className={classes.contentBottom}>
                        <div>
                            <Typography variant='body1'>Total Diskon</Typography>
                            <Typography variant='body1'>Total Ongkir</Typography>
                            <Typography variant='body1'>Total Penjualan</Typography>
                        </div>
                        <div className={classes.dottedBotton}>
                            <Typography variant='body1'>:</Typography>
                            <Typography variant='body1'>:</Typography>
                            <Typography variant='body1'>:</Typography>
                           
                        </div>
                        <div className={classes.titleContentBottom}>
                            <Typography variant='body1'>{new Intl.NumberFormat().format(totalDiskon)}</Typography>
                            <Typography variant='body1'>{new Intl.NumberFormat().format(totalOngkir)}</Typography>
                            <Typography variant='body1'><b>{new Intl.NumberFormat().format(totalPenjualan)}</b></Typography>
                        </div>
                    </div> */}
                </div>
                <div className={classes.buttonLast}>
                    <Button variant='contained' color='primary' onClick={handleClickPrint}>Print</Button>
                </div>
            </div>
    )
})

export default PrintAllPenjualan
